import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

function ArchiveDetailTracks({ 
  tracks, 
  setTracks, 
  styleClasses, 
  handleTrackChange, 
  removeTrack, 
  addTrack,
  mobile
}) {
  // 드래그 종료 시 호출되는 함수
  const onDragEnd = (result) => {
    if (!result.destination) return; // 유효하지 않은 드랍이면 무시

    const newTracks = Array.from(tracks);
    const [removed] = newTracks.splice(result.source.index, 1);
    newTracks.splice(result.destination.index, 0, removed);
    setTracks(newTracks);
  };

  return (
    <div className="formRow">
      <div className="labelBox">
        <label>트랙</label>
        <div className={`commonIcon toolTip ${ mobile ? 'mobile' : '' } ${ styleClasses.topButtonToolTip }`}>
          <i className="questionBlack w16"></i>
          <div className="toolTipText">
            <p>트랙을 자유롭게 추가하고 <br />드래그 앤 드롭하여 순서를 바꿔보세요!</p>
          </div>
        </div>
      </div>
      <div className="fieldBox">
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="tracks" isDropDisabled={ false } isCombineEnabled={ false } ignoreContainerClipping={ false } direction="vertical">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {tracks.map((track, index) => (
                  <Draggable
                    key={track.id || index}
                    draggableId={`track-${track.id || index}`}
                    index={index}
                  >
                    {(provided) => (
                      <div
                        className={styleClasses.eachTrack}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className={styleClasses.leftBox}>
                          <div className="formRow">
                            <div className={`fieldBox checkBox ${ styleClasses.withCheckBox }`}>
                              {
                                (() => {
                                // 현재 제목이 "[TITLE]" 접두사를 가지고 있는지 판단
                                const isTitle = track.title.startsWith("[TITLE]");
                                // 화면에 보여줄 제목: 접두사가 있다면 제거
                                const displayTitle = isTitle ? track.title.replace(/^\[TITLE\]\s*/, '') : track.title;
                                return (
                                  // 체크박스 상태에 따라 접두사를 추가하여 저장
                                  <input type="text" value={displayTitle} placeholder="타이틀" onChange={(e) => { const newText = e.target.value; handleTrackChange(index, 'title', (isTitle ? "[TITLE] " : "") + newText); }} />
                                );
                                })()
                              }
                              <div className="eachBox">
                                {
                                  (() => {
                                // 현재 제목이 "[TITLE]" 접두사를 가지고 있는지 판단
                                const isTitle = track.title.startsWith("[TITLE]");
                                // 화면에 보여줄 제목: 접두사가 있다면 제거
                                const displayTitle = isTitle ? track.title.replace(/^\[TITLE\]\s*/, '') : track.title;
                                return (
                                  <>
                                    {/* 체크박스: 체크 시 타이틀, 체크 해제 시 일반 트랙 제목 */}
                                    <input type="checkbox" id={`title${ index }`} checked={isTitle}
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        // 체크 여부에 따라 제목 앞 접두사를 추가하거나 제거
                                        const newTitle = checked ? "[TITLE] " + displayTitle : displayTitle;
                                        handleTrackChange(index, 'title', newTitle);
                                      }}
                                    />
                                    <label htmlFor={`title${ index }`}>타이틀</label>
                                  </>
                                  );})()
                                }
                              </div>
                            </div>
                          </div>
                          <div className="formRow">
                            <div className="fieldBox">
                              <input
                                type="text"
                                value={track.roles}
                                placeholder="참여"
                                onChange={(e) =>
                                  handleTrackChange(index, 'roles', e.target.value)
                                }
                              />
                            </div>
                          </div>
                          <div className="formRow">
                            <div className="fieldBox">
                              <input
                                type="text"
                                value={track.url}
                                placeholder="음원 링크"
                                onChange={(e) =>
                                  handleTrackChange(index, 'url', e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styleClasses.rightBox}>
                          <div className="formRow">
                            <div className={`commonIcon ${ mobile ? 'mobile' : undefined } ${styleClasses.deleteButton}`}>
                              <button onClick={() => removeTrack(index)}>
                                <i className="trashWhite w24"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <div className="commonIcon">
          <button onClick={addTrack} className={styleClasses.plusButton}>
            <i className="plusBlack w24"></i>
            트랙 추가
          </button>
        </div>
      </div>
    </div>
  );
}

export default ArchiveDetailTracks;
